// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__2NPik","grid_item":"style_grid_item__czLl0","item__icon":"style_item__icon__2bPAH","item__title":"style_item__title__3rsT7"};